import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./404.${locale}.json`));
